module.exports = __webpack_public_path__ + "static/media/Ryker Pitch.367a936f.jpg";